document.addEventListener('DOMContentLoaded', () => {
  // Intersection Observer for Scroll Reveals
  const revealOptions = {
    threshold: 0.15, // Trigger when 15% of the element is visible
    rootMargin: "0px 0px -50px 0px" // Offset slightly so it triggers before bottom
  };

  const revealOnScroll = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      // Add visible class
      entry.target.classList.add('is-visible');

      // Stop observing once revealed
      observer.unobserve(entry.target);
    });
  }, revealOptions);

  // Select all elements to reveal
  const revealElements = document.querySelectorAll('.reveal-on-scroll, .stagger-grid');
  revealElements.forEach(el => revealOnScroll.observe(el));

  // Parallax Effect REMOVED by user request
});
